<div id="top" class="row w-100 pt-3 text-center row-title">
  <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Nouvelle carte</div>
</div>
<div class="col-12 mb-3">
  <div class="row w-100 pt-3">
    <div>
      Lors de l'enregistrement d'une carte bancaire, <span class="bold-text">un paiement de 1 €</span> est demandé pour vérifier les coordonnées et valider l'enregistrement.
      <br/><span class="bold-text">La somme réglée sera déduite de la prochaine facture.</span>
    </div>
  </div>
</div>
<div class="pl-3 pr-3 pt-2">
  @if (paymentDetailsInterface) {
    <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
  }
</div>
